import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/anneescolaire/`;

class AnneescolaireService {
	async getAllAnneescolaire() {
		try {
			const response = await axios.get(API_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getCurrentTrimester(anneeScolaire) {
		const today = new Date(); // Obtient la date d'aujourd'hui
		today.setHours(0, 0, 0, 0); // Réinitialise les heures, minutes, secondes et millisecondes pour avoir une comparaison de date pure

		const debutT1 = new Date(anneeScolaire.debut_trimestre_1);
		const finT1 = new Date(anneeScolaire.fin_trimestre_1);

		const debutT2 = new Date(anneeScolaire.debut_trimestre_2);
		const finT2 = new Date(anneeScolaire.fin_trimestre_2);

		const debutT3 = new Date(anneeScolaire.debut_trimestre_3);
		const finT3 = new Date(anneeScolaire.fin_trimestre_3);

		if (debutT1 <= today && today <= finT1) {
			return 1;
		} else if (debutT2 <= today && today <= finT2) {
			return 2;
		} else if (debutT3 <= today && today <= finT3) {
			return 3;
		} else {
			return null;
		}
	}

	getAnneescolaire(id) {
		return axios.get(`${API_URL}${id}/`);
	}

	createAnneescolaire(data) {
		return axios.post(API_URL, data);
	}

	updateAnneescolaire(id, data) {
		return axios.put(`${API_URL}${id}/`, data);
	}

	deleteAnneescolaire(id) {
		return axios.delete(`${API_URL}${id}/`);
	}

	getCurrentAnneescolaire() {
		return axios.get(`${API_URL}current/`);
	}

	getYearOptions() {
		return this.getAllAnneescolaire().then((years) => {
			// options.unshift({value: null, label: 'Selectionner la salle de year'});
			return years.map((year) => ({
				value: year.id,
				label: year.annee_debut + ' - ' + year.annee_fin
			}));
		});
	}

	copyCompetencesAndMatieres(user) {
		return axios.post(`${API_URL}copy/`, null, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${user.token}`
			}
		});
	}
}

export default new AnneescolaireService();
